module.exports = __webpack_public_path__ + "img/qr-video.f3a89ed.png";